import { render, staticRenderFns } from "./Fifth.vue?vue&type=template&id=5218dd4c&"
import script from "./Fifth.vue?vue&type=script&lang=js&"
export * from "./Fifth.vue?vue&type=script&lang=js&"
import style0 from "./Fifth.vue?vue&type=style&index=0&id=5218dd4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports